<kendo-drawer-container class="k-h-full">
  <kendo-drawer
    #drawer
    [position]="'end'"
    [mode]="'overlay'"
    [expanded]="false"
    [animation]="{
      type: 'slide',
      duration: 200,
    }"
    [width]="drawerSidebarWidth()"
  >
    <ng-template kendoDrawerTemplate>
      <div class="k-h-full">
        <app-todo-planner-sidebar-form (closeSidebar$)="drawer.toggle()" />
      </div>
    </ng-template>
  </kendo-drawer>
  <kendo-drawer-content class="k-h-full">
    <div class="card-wrapper k-h-full k-flex-1">
      <div class="card k-h-full">
        <div class="card-body">
          <app-todo-planner [drawer]="drawer" />
        </div>
      </div>
    </div>
  </kendo-drawer-content>
</kendo-drawer-container>
